import React, { useEffect, useState } from "react";

import { apiCall } from "../../../API/apiCall";
import { toast } from "react-toastify";
import Loader from "../../loader/Loader";
import { useSelector } from "react-redux";

import {
  childNotAllowed,
  pleaseLoginToPerformThis,
} from "../../../constant/constant";
import { Box, Tooltip, Typography } from "@mui/material";

import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";

const Likes = ({ blogData: { blogId, likes }, totalLikes, setTotalLikes }) => {
  const { user } = useSelector((st) => st.user);

  const [isLiked, setIsLiked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetLikes = async () => {
      setIsLoading(true);
      try {
        const response = await apiCall({
          url: `blog/likes/${blogId}`,
          method: "GET",
          params: {
            userId: user?._id,
          },
        });

        if (response.success && response?.data?.blog) {
          setTotalLikes(response?.data?.blog?.likes);
          setIsLiked(response?.data?.isLiked);
        } else {
          setTotalLikes(likes);
        }
      } catch (error) {
        console.error("Error fetching comments:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetLikes();
  }, [blogId]);

  const handleLikeClick = async () => {
    setIsLoading(true);

    try {
      if (!user) {
        toast.error(pleaseLoginToPerformThis);
        return;
      } else if (user?.Username?.length !== 0) {
        toast.error(childNotAllowed);
        return;
      }

      const response = await apiCall({
        url: `blog/likes/${blogId}`,
        method: "POST",
      });

      if (response?.success === true) {
        setTotalLikes(response?.data?.likes);
        setIsLiked(response?.data?.isLiked);
      }
    } catch (error) {
      console.error("Error fetching comments:", error);
      setTotalLikes(totalLikes);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      {isLoading && <Loader />}
      <Box display="flex" alignItems="center" sx={{ marginRight: 2 }}>
        <Tooltip placement="top" title={isLiked ? "UNLIKE" : "LIKE"}>
          {isLiked ? (
            <ThumbUpAltIcon
              sx={{ fontSize: 50, color: "#1976d2", cursor: "pointer" }}
              onClick={handleLikeClick}
            />
          ) : (
            <ThumbUpOffAltIcon
              sx={{ fontSize: 50, color: "#1976d2", cursor: "pointer" }}
              onClick={handleLikeClick}
            />
          )}
        </Tooltip>

        <Typography
          variant="body2"
          component="span"
          sx={{ marginLeft: 0.5, fontWeight: "bold", color: "#333" }}
        >
          {totalLikes} Likes
        </Typography>
      </Box>
    </div>
  );
};

export default Likes;
